<template>
  <div v-if="not_show">
    <v-tabs
      dark grow=""
      background-color="primary"
      show-arrows>
          <v-tab v-for="(item, index) in items" 
            :key="index" :to="item.link" >{{item.name}}</v-tab>   
    </v-tabs> 
  </div>
</template>

<script>
export default {
  props:["not","not_show","not_items"],
  data: () => ({
     tabs:[
       {link:"/cpanel/sms",name:"Messages"}, 
       {link:"/cpanel/services",name:"services"},
       {link:"/cpanel/events",name:"events"},
       {link:"/cpanel/news",name:"news"},
       {link:"/cpanel/sisters",name:"sisters"},
       {link:"/cpanel/communities",name:"communities"},
       {link:"/cpanel/images",name:"gallery images"},
      //  {link:"/cpanel/visiters",name:"visiters"}, 
      //  {link:"/cpanel/banner",name:"Banner"},
     ]
  }),
  computed: {
    phoneSize(){ 
      let  width = this.not.vs.width 
      if(width<1000){
        return true
      }else{
        return false
      }
    },
    us(){
      return this.not.us
    },
    items(){
      if (!this.not_items) {
        return this.tabs
      }else{
        return this.not_items
      }
    }
  },
  methods: { 
    clicked(){}
  },
};
</script>
